import type { IPricingV2Media } from './types';
import type { IPricingV2 } from '../types';

const media: IPricingV2Media = {
  mixedMedia: {
    mediaType: 'image',
  },
};

export default media;

export const data: IPricingV2 = {
  cardContent: {
    emailAndSms: {
      buttons: [],
      description: 'Take your marketing further by reaching customers through both email and SMS.',
      featuresList: [
        {
          listIcon: 'checkmark',
          listText: 'Integrate data',
        },
        {
          listIcon: 'checkmark',
          listText: 'Email AI',
        },
        {
          listIcon: 'checkmark',
          listText: 'Flows AI',
        },
        {
          listIcon: 'checkmark',
          listText: 'SMS AI',
        },
        {
          listIcon: 'checkmark',
          listText: 'Multi-channel attribution',
        },
        {
          listIcon: 'checkmark',
          listText: 'Multi-channel A/B testing',
        },
        {
          listIcon: 'checkmark',
          listText: 'Multi-channel segmentation',
        },
        {
          listIcon: 'checkmark',
          listText: 'SMS Smart Opt-in',
        },
        {
          listIcon: 'checkmark',
          listText: '1-1 product recommendations',
        },
        {
          listIcon: 'checkmark',
          listText: 'Predictive analytics',
        },
      ]
      ,
    },
    email: {
      buttons: [],
      description: 'Grow faster with smarter email marketing that personalizes at scale.',
      featuresList: [
        {
          listIcon: 'checkmark',
          listText: 'Integrate data',
        },
        {
          listIcon: 'checkmark',
          listText: 'Email AI',
        },
        {
          listIcon: 'checkmark',
          listText: 'Flows AI',
        },
        {
          listIcon: 'checkmark',
          listText: 'SMS AI',
        },
        {
          listIcon: 'x-mark',
          listText: 'Multi-channel attribution',
        },
        {
          listIcon: 'x-mark',
          listText: 'Multi-channel A/B testing',
        },
        {
          listIcon: 'x-mark',
          listText: 'Multi-channel segmentation',
        },
        {
          listIcon: 'x-mark',
          listText: 'SMS Smart Opt-in',
        },
        {
          listIcon: 'checkmark',
          listText: '1-1 product recommendations',
        },
        {
          listIcon: 'checkmark',
          listText: 'Predictive analytics',
        },
      ]
      ,
    },
    free: {
      buttons: [],
      description: 'Perfect for getting started and trying out the Klaviyo platform.',
      featuresList: [
        {
          listIcon: 'checkmark',
          listText: 'Integrate data',
        },
        {
          listIcon: 'x-mark',
          listText: 'Email AI',
        },
        {
          listIcon: 'x-mark',
          listText: 'Flows AI',
        },
        {
          listIcon: 'x-mark',
          listText: 'SMS AI',
        },
        {
          listIcon: 'x-mark',
          listText: 'Multi-channel attribution',
        },
        {
          listIcon: 'x-mark',
          listText: 'Multi-channel A/B testing',
        },
        {
          listIcon: 'x-mark',
          listText: 'Multi-channel segmentation',
        },
        {
          listIcon: 'x-mark',
          listText: 'SMS Smart Opt-in',
        },
        {
          listIcon: 'x-mark',
          listText: '1-1 product recommendations',
        },
        {
          listIcon: 'x-mark',
          listText: 'Predictive analytics',
        },
      ]
      ,
    },
  },
  platformCards: {
    customerDataPlatform: {
      buttons: [],
      description: 'The smarter, easier CDP built right in the platform for faster results.',
      featuresList: [
        {
          listIcon: 'checkmark',
          listText: 'Includes Advanced Analytics',
        },
        {
          listIcon: 'checkmark',
          listText: 'Sync data to warehouses and other platforms with a single source of truth',
        },
        {
          listIcon: 'checkmark',
          listText: 'No-code transformations and advanced ID resolution ',
        },
      ],
    },
    reviews: {
      buttons: [],
      description: 'Built-in product reviews that make everything smarter.',
      featuresList: [
        {
          listIcon: 'checkmark',
          listText: ' Collect and display reviews within Klaviyo, using your brand assets',
        },
        {
          listIcon: 'checkmark',
          listText: 'Use reviews data for targeted campaigns',
        },
        {
          listIcon: 'checkmark',
          listText: 'Automate review requests and responses',
        },
      ],
    },
    marketingAnalytics: {
      buttons: [],
      description: 'Unlock advanced features for insights and reporting.',
      featuresList: [
        {
          listIcon: 'checkmark',
          listText: 'Target based on customer purchase behavior',
        },
        {
          listIcon: 'checkmark',
          listText: 'Personalize cross-sells with catalog insights',
        },
        {
          listIcon: 'checkmark',
          listText: 'Easily report on trends and impact',
        },
      ],
    },
    backgroundColor: 'eggplant',
    topRip: {
      rip: {
        backgroundColor: 'eggplant',
        direction: 'bottom',
        orientation: 'original',
        ripColor: 'white',
        ripVariant: 'b',
        customPadding: {
          customPaddingBottom: 'none',
          customPaddingTop: 'none',
        },
      },
    },
    bottomRip: {
      rip: {
        backgroundColor: 'white',
        direction: 'bottom',
        orientation: 'original',
        ripColor: 'eggplant',
        ripVariant: 'a',
        customPadding: {
          customPaddingBottom: 'none',
          customPaddingTop: 'none',
        },
      },
    },
  },
};
